import { Typography, Grid, styled } from "@mui/material";

interface WsSectionTitleProps {
  title: string;
  subtitle?: string;
  color?: string;
  fontSize?: string;
}

function WsSectionTitle({
  title,
  subtitle,
  color,
  fontSize = "1.6rem",
}: WsSectionTitleProps) {
  return (
    <Title fontSize={fontSize} fontWeight={700} color={color}>
      {title}
    </Title>
  );
}

export default WsSectionTitle;

const Title = styled(Typography)`
  text-align: center;
  text-wrap: wrap;
  font-size: 1.8rem;
  @media screen and (max-width: 768px) {
    font-size: 1.4rem;
  }
`;
